module.exports = __webpack_public_path__ + "AvenirNextCondensed-Medium.ttf";